import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Grid,
  Box,
  TextField,
  Button,
  Container,
  CardContent,
  InputAdornment,
} from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PercentIcon from "@mui/icons-material/Percent";
import moment from "moment";
import { postData, putData, getData } from "../../../../services/library"; // Ajusta según tus funciones de API
import Notify from "../../../Notify"; // Ajusta según tu componente de notificación
import { logEventos } from "../../../../services/services"; // Ajusta según tu función de logging

export default function AddPrecioAlta(props) {
  const [direccion, setDireccion] = useState([]);
  const [datoslista, setDatoslista] = useState({
    id_cliente: props.datos.id,
    lt_con_iva: "",
    lt_sin_iva: "",
    kg_con_iva: "",
    kg_sin_iva: "",
    vigencia: "",
    fin_vigencia: null,
  });
  const [disabledGuardar, setDisabledGuardar] = useState(true);
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  const [aumento, setAumento] = useState(null);
  const [desactivarPorcentaje, setDesactivarPorcentaje] = useState(false);
  const [desactivarPesos, setDesactivarPesos] = useState(false);
  const [porcentaje, setPorcentaje] = useState(null);
  const truncar = (num) =>
    Number(num).toFixed(2).replace('.', ',');

  const style = { margin: "10px 0" };

  const formatoParaMostrar = (valor) => {
    if (valor === null || valor === undefined) return '';
    if (typeof valor === 'number') {
      return valor.toFixed(2).replace('.', ',');
    }
    return valor.replace('.', ',');
  };

  // Cargar datos de dirección
  useEffect(() => {
    getData('/direccionesentrega/producto/' + props.datos.id, setDireccion);
  }, [props.datos.id]);

  // Establecer vigencia inicial como el día siguiente a fin_vigencia
  useEffect(() => {
    if (props.listaPrecios[0]?.fin_vigencia) {
      const finVigencia = moment(props.listaPrecios[0].fin_vigencia);
      const nuevaVigencia = finVigencia.add(1, 'day').format('YYYY-MM-DD');
      setDatoslista((prev) => ({
        ...prev,
        vigencia: nuevaVigencia,
      }));
    }
  }, [props.listaPrecios]);

  // Habilitar/deshabilitar botón Guardar
  useEffect(() => {
    if (
      !datoslista.lt_con_iva ||
      !datoslista.lt_sin_iva ||
      !datoslista.kg_con_iva ||
      !datoslista.kg_sin_iva ||
      !datoslista.vigencia
    ) {
      setDisabledGuardar(true);
    } else {
      setDisabledGuardar(false);
    }
  }, [datoslista]);

  const handleAumentoChange = (e) => {
    const nuevoAumento = e.target.value;
    setAumento(nuevoAumento);
    setDesactivarPorcentaje(nuevoAumento !== "");
    setPorcentaje(null);

    const preciosOriginales = props.listaPrecios[0] || {};

    if (nuevoAumento === "") {
      setDatoslista({
        ...datoslista,
        kg_sin_iva: "",
        lt_sin_iva: "",
        kg_con_iva: "",
        lt_con_iva: "",
      });
      return;
    };

    const valorIva = direccion[0]?.valor || 1;

    const densidad =
      props.datos.id_empresa === 1
        ? direccion[0]?.densidad_hipergas || 1
        : direccion[0]?.densidad_autogas || 1;

    if (!isNaN(nuevoAumento)) {
      const aumentoNumerico = parseFloat(nuevoAumento);
      const kg_sin_iva = (parseFloat(preciosOriginales.kg_sin_iva) || 0) + aumentoNumerico;
      const kg_con_iva = kg_sin_iva * valorIva;
      const lt_sin_iva = kg_sin_iva * densidad;
      const lt_con_iva = kg_con_iva * densidad;

      setDatoslista({
        ...datoslista,
        kg_sin_iva: truncar(kg_sin_iva),
        kg_con_iva: truncar(kg_con_iva),
        lt_sin_iva: truncar(lt_sin_iva),
        lt_con_iva: truncar(lt_con_iva),
      });
    } else {
      const kg_sin_iva = parseFloat(preciosOriginales.kg_sin_iva) || 0;
      const kg_con_iva = kg_sin_iva * valorIva;
      const lt_sin_iva = kg_sin_iva * densidad;
      const lt_con_iva = kg_con_iva * densidad;

      setDatoslista({
        ...datoslista,
        kg_sin_iva: truncar(kg_sin_iva),
        kg_con_iva: truncar(kg_con_iva),
        lt_sin_iva: truncar(lt_sin_iva),
        lt_con_iva: truncar(lt_con_iva),
      });
    }
  };

  const handlePorcentajeChange = (e) => {
    const nuevoPorcentaje = e.target.value;
    setPorcentaje(nuevoPorcentaje);
    setDesactivarPesos(nuevoPorcentaje !== "");
    setAumento(null);

    if (nuevoPorcentaje === "") {
      setDatoslista({
        ...datoslista,
        kg_sin_iva: "",
        lt_sin_iva: "",
        kg_con_iva: "",
        lt_con_iva: "",
      });
      return;
    };

    const preciosOriginales = props.listaPrecios[0] || {};

    const valorIva = direccion[0]?.valor || 1;

    if (!isNaN(nuevoPorcentaje)) {
      const porcentajeNumerico = parseFloat(nuevoPorcentaje) / 100;
      const nuevoPrecioKiloSinIva = preciosOriginales.kg_sin_iva * (1 + porcentajeNumerico);

      const densidad =
        props.datos.id_empresa === 1
          ? direccion[0]?.densidad_hipergas || 1
          : direccion[0]?.densidad_autogas || 1;

      const nuevoPrecioLitroSinIva = nuevoPrecioKiloSinIva * densidad;
      const nuevoPrecioKiloConIva = nuevoPrecioKiloSinIva * valorIva;
      const nuevoPrecioLitroConIva = nuevoPrecioLitroSinIva * valorIva;

      setDatoslista({
        ...datoslista,
        kg_sin_iva: truncar(nuevoPrecioKiloSinIva),
        kg_con_iva: truncar(nuevoPrecioKiloConIva),
        lt_sin_iva: truncar(nuevoPrecioLitroSinIva),
        lt_con_iva: truncar(nuevoPrecioLitroConIva),
      });
    } else {
      setDatoslista({
        ...datoslista,
        kg_sin_iva: "",
        kg_con_iva: "",
        lt_sin_iva: "",
        lt_con_iva: "",
      });
    }
  };

  const almacenar = (event) => {
    const { name, value } = event.target;
    let newValue = { ...datoslista, [name]: value };

    if (value === "") {
      setDatoslista({
        ...datoslista,
        lt_sin_iva: "",
        lt_con_iva: "",
        kg_sin_iva: "",
        kg_con_iva: "",
        [name]: "",
      });
      return;
    };

    // Convertir entrada a número
    const valorNormalizado = value.replace(',', '.');
    const floatValue = parseFloat(valorNormalizado);

    const densidad =
      direccion && props.datos.id_empresa === 1
        ? direccion[0].densidad_hipergas
        : direccion[0].densidad_autogas;

    const truncar = (num) =>
      Number(num).toFixed(2).replace('.', ',');

    //LÓGICA DE CALCULOS
    if (name === "lt_sin_iva") {
      const precioConIva = floatValue * direccion[0].valor;
      const kgConIva = precioConIva / densidad;
      const kgSinIva = kgConIva / direccion[0].valor;
      newValue.kg_sin_iva = truncar(kgSinIva);
      newValue.lt_con_iva = truncar(precioConIva);
      newValue.kg_con_iva = truncar(kgConIva);
    }
    else if (name === "kg_sin_iva") {
      const precioConIva = floatValue * direccion[0].valor;
      const ltConIva = precioConIva * densidad;
      const ltSinIva = ltConIva / direccion[0].valor;
      newValue.lt_sin_iva = truncar(ltSinIva);
      newValue.kg_con_iva = truncar(precioConIva);
      newValue.lt_con_iva = truncar(ltConIva);
    }
    else if (name === "kg_con_iva") {
      const precioSinIva = floatValue / direccion[0].valor;
      const ltConIva = precioSinIva / densidad;
      const ltSinIva = ltConIva / direccion[0].valor;
      newValue.lt_sin_iva = truncar(ltSinIva);
      newValue.kg_sin_iva = truncar(precioSinIva);
      newValue.lt_con_iva = truncar(ltConIva);
    }
    else if (name === "lt_con_iva") {
      const precioSinIva = floatValue / direccion[0].valor;
      const kgSinIva = precioSinIva * densidad;
      const kgConIva = kgSinIva * direccion[0].valor;
      newValue.kg_con_iva = truncar(kgConIva);
      newValue.lt_sin_iva = truncar(precioSinIva);
      newValue.kg_sin_iva = truncar(kgSinIva);
    }
    setDatoslista(newValue);
  };

  const handleChangeVigencia = (e) => {
    const nuevaVigencia = e.target.value;
    setDatoslista((prev) => ({
      ...prev,
      vigencia: nuevaVigencia,
    }));
  };

  const guardarPrecio = async (e) => {
    e.preventDefault();
    setDisabledGuardar(true);

    const getNumericValue = (value) => {
      if (!value || typeof value !== 'string') return 0;
      const normalized = value.replace(',', '.');
      const parsed = parseFloat(normalized);
      return isNaN(parsed) ? 0 : parsed;
    };

    const precios = {
      lt_con_iva: getNumericValue(datoslista.lt_con_iva),
      lt_sin_iva: getNumericValue(datoslista.lt_sin_iva),
      kg_con_iva: getNumericValue(datoslista.kg_con_iva),
      kg_sin_iva: getNumericValue(datoslista.kg_sin_iva),
    };

    if (Object.values(precios).some(val => val === 0)) {
      setNotificacion({
        open: true,
        mensaje: "Todos los precios deben ser mayores a 0",
        severity: "error",
        color: "#f44336",
      });
      setDisabledGuardar(false);
      return;
    }

    const vigencia = datoslista.vigencia || moment().format('YYYY-MM-DD');

    try {
      await postData(e, '/precios_especiales', {
        id_cliente: props.datos.id,
        ...precios,
        vigencia,
        usuario: localStorage.getItem("user"),
        fin_vigencia: datoslista.fin_vigencia || null,
        aumento_en_pesos: aumento,
        aumento_en_porcentaje: porcentaje
      }, setNotificacion);

      logEventos("Guardar nuevo precio especial", "Precio especiales", "referencias tabla", localStorage.getItem('user'));

      if (props.listaPrecios[0] && vigencia) {
        const finVigencia = moment(vigencia).subtract(1, 'day').format('YYYY-MM-DD');
        await putData(
          e,
          `/precios_especiales/${props.listaPrecios[0].id_precioespecial}`,
          {
            fin_vigencia: finVigencia,
          },
          setNotificacion
        );
        props.actualizar();
      }

      props.onClose();
    } catch (error) {
      setNotificacion({
        open: true,
        mensaje: `Error al guardar: ${error.message}`,
        severity: "error",
        color: "#f44336",
      });
      setDisabledGuardar(false);
    }
  };

  const handleKeyDown = (e) => {
    // Permitir números y la coma
    if (!(
      (e.key >= '0' && e.key <= '9') ||
      e.key === ',' ||
      e.key === 'Backspace' ||
      e.key === 'ArrowLeft' ||
      e.key === 'ArrowRight' ||
      e.key === 'Tab'
    )) {
      e.preventDefault();
    }
  };


  return (
    <div>
      <Dialog
        maxWidth="lg"
        open={props.open}
        onClose={() => props.onClose(false)}
        style={{ zIndex: 1 }}
      >
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography variant="h6" align="center" color="#ffffff">
              Precio especial para cliente {props.datos.razon_social}
            </Typography>
          </DialogTitle>
        </Box>
        <DialogContent>
          <Container>
            <form onSubmit={guardarPrecio} autoComplete="off">
              <Box
                backgroundColor="#F4F6F6"
                mt={1}
                p={3}
                border={0.5}
                borderColor={"#ABB2B9"}
                borderRadius={4}
              >
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}
                  mt={1}
                >
                  {props.listaPrecios && props.listaPrecios.length > 0 ? (
                    <>
                      <Typography sx={{ fontSize: 19, mb: 2, textDecoration: "underline", textAlign: "center" }}>
                        Precio Vigente
                      </Typography>
                      <Grid container spacing={1} alignItems="center" justifyContent="center">
                        {[
                          { label: "Precio litro sin IVA", value: props.listaPrecios[0]?.lt_sin_iva || 0 },
                          { label: "Precio litro con IVA", value: props.listaPrecios[0]?.lt_con_iva || 0 },
                          { label: "Precio kilo sin IVA", value: props.listaPrecios[0]?.kg_sin_iva || 0 },
                          { label: "Precio kilo con IVA", value: props.listaPrecios[0]?.kg_con_iva || 0 },
                        ].map((item, index) => (
                          <Grid item xs={12} sm={6} md={2} key={index}>
                            <TextField
                              fullWidth
                              style={style}
                              focused
                              size="small"
                              variant="outlined"
                              label={item.label}
                              value={formatoParaMostrar(item.value)}
                              InputProps={{ readOnly: true }}
                            />
                          </Grid>
                        ))}
                        <Grid item xs={12} sm={6} md={2}>
                          <TextField
                            fullWidth
                            style={style}
                            focused
                            size="small"
                            variant="outlined"
                            label="Entrada en Vigencia"
                            value={moment(props.listaPrecios[0]?.vigencia).format("DD-MM-YYYY") || ""}
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                          <TextField
                            fullWidth
                            style={style}
                            focused
                            size="small"
                            variant="outlined"
                            label="Fin Vigencia"
                            value={props.listaPrecios[0]?.fin_vigencia ? moment(props.listaPrecios[0].fin_vigencia).format("DD-MM-YYYY") : "No hay registro"}
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>
                      </Grid>

                      <CardContent>
                        <Typography sx={{ fontSize: 19, mb: 2, textDecoration: "underline", textAlign: "center" }}>
                          Actualización
                        </Typography>
                        <Grid container spacing={1} alignItems="center" justifyContent="center">
                          <Grid item xs={12} sm={6} md={6}>
                            <TextField
                              fullWidth
                              style={style}
                              focused
                              size="small"
                              color="secondary"
                              label="Actualización en pesos"
                              variant="outlined"
                              type="number"
                              value={aumento}
                              onChange={handleAumentoChange}
                              disabled={desactivarPesos}
                              InputProps={{
                                startAdornment: <InputAdornment position="start"><AttachMoneyIcon /></InputAdornment>,
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} md={6}>
                            <TextField
                              fullWidth
                              size="small"
                              style={style}
                              focused
                              type="number"
                              color="secondary"
                              label="Actualización en porcentaje"
                              variant="outlined"
                              value={porcentaje}
                              onChange={handlePorcentajeChange}
                              disabled={desactivarPorcentaje}
                              InputProps={{
                                startAdornment: <InputAdornment position="start"><PercentIcon /></InputAdornment>,
                              }}
                            />
                          </Grid>
                        </Grid>
                      </CardContent>

                      <CardContent>
                        <Typography sx={{ fontSize: 19, mb: 2, textDecoration: "underline", textAlign: "center" }}>
                          Precio actualizado
                        </Typography>
                        <Grid container spacing={1} alignItems="center" justifyContent="center">
                          {[
                            { label: "Precio litro sin IVA", name: "lt_sin_iva", value: datoslista.lt_sin_iva || "" },
                            { label: "Precio litro con IVA", name: "lt_con_iva", value: datoslista.lt_con_iva || "" },
                            { label: "Precio kilo sin IVA", name: "kg_sin_iva", value: datoslista.kg_sin_iva || "" },
                            { label: "Precio kilo con IVA", name: "kg_con_iva", value: datoslista.kg_con_iva || "" },
                          ].map((item, index) => (
                            <Grid item xs={12} sm={6} md={2} key={index}>
                              <TextField
                                fullWidth
                                style={style}
                                focused
                                size="small"
                                variant="outlined"
                                label={item.label}
                                name={item.name}
                                value={formatoParaMostrar(item.value)}
                                onChange={almacenar}
                                InputProps={{ readOnly: true }}
                              />
                            </Grid>
                          ))}
                          <Grid item xs={12} sm={6} md={2}>
                            <TextField
                              fullWidth
                              style={style}
                              focused
                              size="small"
                              variant="outlined"
                              label="Fecha de entrada en vigencia"
                              type="date"
                              inputProps={{
                                min: props.listaPrecios[0]?.fin_vigencia
                                  ? moment(props.listaPrecios[0].fin_vigencia).add(1, 'day').format('YYYY-MM-DD')
                                  : undefined,
                              }}
                              name="vigencia"
                              value={datoslista.vigencia || ""}
                              onChange={handleChangeVigencia}
                            />
                          </Grid>
                        </Grid>
                      </CardContent>
                    </>
                  ) : (
                    <Grid container spacing={2}>
                      {["lt_sin_iva", "lt_con_iva", "kg_sin_iva", "kg_con_iva"].map((name, index) => (
                        <Grid item xs={12} sm={6} md={2} key={index}>
                          <TextField
                            fullWidth
                            size="small"
                            style={style}
                            focused
                            color="primary"
                            required
                            name={name}
                            label={`Precio ${name.replace("_", " ")}`}
                            variant="outlined"
                            value={datoslista[name]}
                            onChange={almacenar}
                            onKeyDown={(e) => { handleKeyDown(e) }}
                            onPaste={(e) => {
                              const pastedText = e.clipboardData.getData('text');
                              if (pastedText.includes('.')) {
                                e.preventDefault();
                              }
                            }}
                            inputProps={{
                              inputMode: 'decimal',
                              pattern: '[0-9]*[,]{0,1}[0-9]{0,2}',
                            }}
                          />
                        </Grid>
                      ))}
                      <Grid item xs={12} sm={6} md={2}>
                        <TextField
                          fullWidth
                          size="small"
                          style={style}
                          focused
                          color="primary"
                          type="date"
                          name="vigencia"
                          label="Vigencia"
                          variant="outlined"
                          value={datoslista.vigencia}
                          onChange={handleChangeVigencia}
                        />
                      </Grid>
                    </Grid>
                  )}
                </Grid>

                <Grid container justifyContent="space-between" alignItems="flex-end" mt={2}>
                  <Button variant="contained" onClick={() => props.onClose(false)} color="error">
                    Volver
                  </Button>
                  <Button
                    variant="contained"
                    type="submit"
                    color="success"
                    disabled={disabledGuardar}
                  >
                    Guardar Precio
                  </Button>
                </Grid>
              </Box>
            </form>
            {notificacion && notificacion.open ? (
              <Notify
                mensaje={notificacion.mensaje}
                open={notificacion.open}
                color={notificacion.color}
                handleClose={props.onClose}
                severity={notificacion.severity}
              />
            ) : null}
          </Container>
        </DialogContent>
      </Dialog>
    </div>
  );
}